import { useQuery, skipToken } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { DashboardMerchantsSummaryParams } from 'config/requests/dashboard';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { EntitiesSummary } from 'types/embedded/dashboard';
import { ErrorData } from 'types/embedded/error';

import { useDashboardApi } from './useDashboardApi';

export function useGetDashboardMerchantsSummary(params: DashboardMerchantsSummaryParams | null) {
  const translate = useTypedTranslate();
  const { api, aggregatedQueryKey } = useDashboardApi();

  const {
    data: summary,
    isLoading,
    isFetching,
    error,
  } = useQuery<EntitiesSummary, AxiosError<ErrorData>>({
    queryKey: ['dashboard/top_merchants', aggregatedQueryKey, params],
    queryFn: params ? () => api.getMerchantsSummary(params) : skipToken,
  });

  const errorMessage = error
    ? error.response?.data?.errors?.[0].title || translate('app.common.serverError')
    : undefined;

  return { summary, isLoading, isFetching, error: errorMessage };
}

export type GetDashboardMerchantsSummaryResult = ReturnType<typeof useGetDashboardMerchantsSummary>;
